<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="code"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.code"
        :form-state="formState"
        name="code"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.code"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="name"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.name"
        :form-state="formState"
        name="name"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.name"
      ></o-text-field>
    </o-widget-wrapper>

    <o-widget-wrapper
      v-if="!inModal"
      :schema="schema"
      name="active_start_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.active_start_date"
        name="active_start_date"
        v-bind="schema.fields.active_start_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
      ></o-date-time>
    </o-widget-wrapper>

    <o-widget-wrapper
      v-if="!inModal"
      :schema="schema"
      name="active_end_date"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-date-time
        v-model="item.active_end_date"
        name="active_end_date"
        v-bind="schema.fields.active_end_date"
        :form-state="formState"
        :validators="$v.item"
        :server-errors="_se"
      ></o-date-time>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("Customer"),
    CreateCodeTableFetchMixin([]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.Customer, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
